var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{fixios: _vm.isIOS && _vm.isQYWeixin},attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":"KeepHome"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }